import { Component, Input, OnInit, ViewChild } from '@angular/core';

import { SwiperComponent } from 'swiper/angular';
import SwiperCore, { Navigation, Thumbs, Virtual } from 'swiper';

SwiperCore.use([Navigation, Thumbs, Virtual]);

@Component({
  selector: 'app-item-slider',
  templateUrl: './item-slider.component.html',
  styleUrls: ['./item-slider.component.scss'],
})
export class ItemSliderComponent implements OnInit {
  @ViewChild('swiperSecondary', { static: false })
  swiperSecondary?: SwiperComponent;
  @Input() slides: any[] = [];

  public thumbsSwiper: any = null;

  constructor() {}

  ngOnInit(): void {}

  slideNext() {
    this.swiperSecondary.swiperRef.slideNext(100);
  }
  slidePrev() {
    this.swiperSecondary.swiperRef.slidePrev(100);
  }
}
